<!--
make sure you have the following script on your page for this to work:
<script src="https://www.google.com/recaptcha/api.js?render=explicit" async defer></script>
-->

<template>
  <div ref="captchaEl"></div>
</template>

<script setup>
import { ref, onMounted, defineEmits, defineProps, defineExpose } from 'vue'

const props = defineProps({
  siteKey: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['solved'])

const captchaEl = ref(null)
const captchaId = ref(null)

function init() {
  if (typeof window.grecaptcha === 'undefined' || !window.grecaptcha.render) {
    setTimeout(init, 100)
    return
  }

  captchaId.value = window.grecaptcha.render(captchaEl.value, {
    sitekey: props.siteKey,
    callback: solved,
    'expired-callback': expired
  })
}

function getResponse() {
  if (captchaId.value === null) return null
  return window.grecaptcha.getResponse(captchaId.value)
}

function solved() {
  emit('solved', true)
}

function expired() {
  emit('solved', false)
}

onMounted(() => {
  init()
})

defineExpose({
  getResponse
})
</script>
